import { Navigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"

interface RouteRedirectProps {
  to: "customer" | "invoicing" | "org" | "vaaratapahtuma" | "korjauspyynto" | "muistutus"
}

/**
 * Component that redirects from route aliases to canonical localized paths.
 * For example: /fi/customer → /fi/asiakas, /fi/feedback → /fi/asiakas
 */
const RouteRedirect = ({ to }: RouteRedirectProps) => {
  const { lang } = useParams<{ lang: string }>()
  const { t } = useTranslation()

  // Get the canonical path for the target route in the current language
  const canonicalPath = t(`routes.${to}.canonical`)

  // Construct the full redirect path with language prefix
  const redirectPath = `/${lang}/${canonicalPath}`

  return <Navigate to={redirectPath} replace />
}

export default RouteRedirect
